module.exports = __webpack_public_path__ + "img/send-offer-desktop-fr.cf815f6c.jpg";